export const environment = {
  production: true,
  rrd_path : "RRD_PATH" in process.env ? process.env.RRD_PATH : "/opt/gpon/apps/ip6m/src/assets/rrds/",
  png_path: "PNG_PATH" in process.env ? process.env.PNG_PATH : "/opt/gpon/apps/ip6m/assets/rrd_charts/",
  client_chart_path : "CLIENT_CHART_PATH" in process.env ? process.env.CLIENT_CHART_PATH : "/assets/rrd_charts/",
  frontendBaseUrl: "FRONTEND_URL" in process.env ? process.env.FRONTEND_URL : 'http://localhost',
  dbConfig: {
    type: "DB_TYPE" in process.env ? process.env.DB_TYPE : 'mysql',
    host: "DB_HOST" in process.env ? process.env.DB_HOST : 'localhost',
    port: "DB_PORT" in process.env ? process.env.DB_PORT : 3306,
    username: "DB_USER" in process.env ? process.env.DB_USER : 'gpon',
    password: "DB_PASSWORD" in process.env ? process.env.DB_PASSWORD : 'gpon',
    database: "DB_NAME" in process.env ? process.env.DB_NAME : 'gpon'
  },
  bcryptSaltRounds: 10,
  messengerService: 'console',
  jwtSecret: "JWTSECRET" in process.env ? process.env.JWTSECRET : 'jwtSecret123456'
};
